import { useCallback, useMemo } from 'react'
import { Bot } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchBotFarms, SEC_STR as S, type DeviceRow } from './securityMoreApi'

/**
 * A18.14 — Бот-фермы. Device fingerprints from the LIVE
 * `GET /admin/antifraud/devices` feed, densest first — one device shared by many
 * accounts is the strongest bot-farm signal.
 */
export function BotFarmsScreen() {
  const columns = useMemo<AdminColumn<DeviceRow>[]>(
    () => [
      { key: 'id', header: S.device, type: 'id' },
      { key: 'platform', header: S.platform, type: 'text', width: 130 },
      { key: 'accounts', header: S.accounts, type: 'number', width: 120 },
      { key: 'flagged', header: S.flagged, type: 'bool', width: 100, align: 'center' },
      { key: 'first_seen', header: S.firstSeen, type: 'date', width: 150 },
      { key: 'last_seen', header: S.lastSeen, type: 'date', width: 150 },
    ],
    [],
  )
  const fetcher = useCallback(fetchBotFarms, [])
  return (
    <>
      <PageHeader title={S.botFarms} screenId="A18.14" />
      <DataTable<DeviceRow>
        screenId="A18.14"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <Bot size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
